import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, subtitle, image, testId }) {
  return (
    <section
      data-testid={testId || "page-hero"}
      className="relative min-h-[62vh] w-full overflow-hidden bg-ink"
    >
      <img
        src={image}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="hero-overlay absolute inset-0" />

      <div className="container-narrow relative z-10 flex min-h-[62vh] flex-col justify-end pb-16 pt-40 md:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-3xl"
        >
          {eyebrow && (
            <span className="text-[11px] font-medium uppercase tracking-[0.32em] text-white/85">
              {eyebrow}
            </span>
          )}
          <h1 className="mt-5 text-4xl font-bold leading-[1.05] text-white sm:text-5xl md:text-6xl lg:text-[68px]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
              {subtitle}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
